import {
  AdminProctorDetailsProvider,
  AdminProctorDetailsHeader,
} from '@exam-center/admin-proctor-details';
import { useParams } from '@exam-center/router';
import { Box } from '@shared/components';
import { Outlet } from 'react-router-dom';
export default function AdminProctorsLayout() {
  const { examCenterProctorId } = useParams('/admin/exam-proctors/proctors/:examCenterProctorId');

  return (
    <AdminProctorDetailsProvider proctorId={examCenterProctorId}>
      <AdminProctorDetailsHeader />
      <Box sx={{ p: (theme) => theme.spacing(6), flex: 1 }}>
        <Outlet />
      </Box>
    </AdminProctorDetailsProvider>
  );
}
